module.exports = __webpack_public_path__ + "img/worksbot_img19121303.4777b898.jpg";